import React from 'react';

const DotSeparator: React.FC = () => {
  return (
    <span
      className="pds-mx-3 pds-hidden pds-text-display-sm pds-leading-3 md:pds-block"
      aria-hidden="true"
    >
      &#183;
    </span>
  );
};

export default DotSeparator;
